module.exports = __webpack_public_path__ + "static/logo-6c80568def72b6231aeb942e4f4213c2.png";